import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';

import { AuthService } from '../../services/AuthService';
import { UserService } from '../../services/UserService';
import useRequest from '../../hooks/useRequest';
import { isMobile } from '../../helpers/Mobile';

import LoginHeader from '../../components/atoms/LoginHeader';
import InputText from '../../components/atoms/InputText';
import GradientButton from '../../components/atoms/GradientButton';
import Icon from '../../components/atoms/Icon';
import SpinnerAbsa from 'components/atoms/SpinnerAbsa';

import './styles.scss';
import FooterMobile from '../../components/atoms/FooterMobile';

const ForgottenPasswordView = (props) => {
    const {
        submitted, success, message, errors, 
        beforeSubmit, afterSubmit, showError, showSuccess, 
        dealWithError
    } = useRequest();

    const [email, setEmail] = useState("");
    const [showButton, setshowButton] = useState(true);

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        const data = {
            email: email,
        }

        UserService.requestPassword(data)
            .then(data => {
                afterSubmit();
                showSuccess('Hemos enviado un e-mail a la casilla de correo indicada para recuperar tu contraseña.')
                setshowButton(false);
            }).catch((error) => {
                dealWithError(error, '');
            });
    }

    return (
        <div className="forgotten-password-container">
            <LoginHeader></LoginHeader>

            <div className="forgotten-password-content">
                <form className="forgotten-password-form" onSubmit={handleSubmit}>
                    <h1 className="forgotten-password-title">Recupero de contraseña</h1>
                    <h2 className="forgotten-password-subtitle" style={showButton ? { display: 'flex' } : { display: 'none' }}>Ingresá tu e-mail para que te enviemos un correo con un link para restablecer tu contraseña</h2>
                    <div className="forgotten-password-input-group" style={showButton ? { display: 'flex' } : { display: 'none' }}>
                        <div className="forgotten-password-input-icon-container">
                            <Icon name="email" width={26} height={17} fill={'#1F3BA3'} />
                        </div>
                        <div className="forgotten-password-input-container">
                            <InputText id="email" label="" placeholder="Ingresá el e-mail asociado a la cuenta"
                                handleChange={(event) => { setEmail(event.target.value) }} error={errors.email}/>
                        </div>
                    </div>
                    {(success === false && message) &&
                        <p className="error-messages">{message}</p>
                    }
                    {(success === true && message) &&
                        <p className="success-messages">{message}</p>
                    }
                    <div className="forgotten-password-button" style={showButton ? { display: 'flex' } : { display: 'none' }}>
                        <GradientButton legend={'CONTINUAR'} disabled={submitted}
                            handleClick={handleSubmit} type={'submit'} />
                    </div>
                </form>
            </div>
            {isMobile && <FooterMobile></FooterMobile>}
            <SpinnerAbsa></SpinnerAbsa>
        </div>
    );
}

export default withTranslation()(ForgottenPasswordView);